import { IState } from 'shared/store';

export const getNewbuildingId = (state: IState): number => {
  return state.offerData.offer.newbuilding.id;
};
